<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' width='700px' center
             @close='closeDialog' :close-on-click-modal='false'>
    <div style='padding: 20px;width: 100%' v-loading='loading'>
      <el-form :model='form' :rules='rules' label-width='150px' ref='ruleForm'
               class='demo-ruleForm'>
        <el-form-item label='上级字典：'>
          <tree-select
            :props="{
                children: 'sonCategory',
                label: 'categoryName',
                value:'id'
              }"
            v-model='form.parentId'
            :options='treeData' />
        </el-form-item>
        <el-form-item label='字典名称：' prop='categoryName'>
          <el-input size='mini' style='width: 70%' v-model='form.categoryName'
                    placeholder='请输入字典名称'></el-input>
        </el-form-item>
        <el-form-item label='排序：'>
          <el-input size='mini' style='width: 70%' v-model='form.sort'
                    placeholder='请输入排序' type='number'></el-input>
        </el-form-item>
        <el-form-item style='display: flex;justify-content: center;' label-width='0px'>
          <el-button size='medium' class='searchBtn' @click='submit'>
            {{ dialogTitle === '修改字典' ? '修改' : '确认' }}
          </el-button>
          <el-button size='medium' class='resetBtn' @click='closeDialog'>关闭</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
  import treeSelect from '@/components/treeSelect';
  import { categoryAdd, categoryDetail, categoryUpdate } from '@/service/basicfile';

  export default {
    name: 'dictionariesForm',
    components: { treeSelect },
    data() {
      return {
        dialogTitle: '新增',
        dialogVisible: false,
        defaultForm: {},
        form: {
          categoryName: '',
          parentId: '',
          sort: '',
        },
        rules: {
          categoryName: {
            required: true,
            message: '请输入字典名称',
            trigger: 'blur',
          },
        },
        treeData: [],
        loading: false,
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      openDialog(data, row) {
        this.treeData = data;
        row ? this.dialogTitle = '修改字典' : this.dialogTitle = '新增字典';
        if (row) {
          this.dialogTitle = '修改字典';
          this.getInfo(row.id);
        }
        this.dialogVisible = true;
      },
      async getInfo(id) {
        this.loading = true;
        const { data } = await categoryDetail({ id });
        this.form = {
          id: data.id,
          categoryName: data.categoryName,
          parentId: data.parentId || '',
          sort: data.sort || '',
        };
        this.loading = false;
      },
      closeDialog() {
        this.dialogVisible = false;
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
      },
      async submit() {
        let data;
        if (this.dialogTitle === '新增字典') {
          data = await categoryAdd(this.form);
        } else {
          data = await categoryUpdate(this.form);
        }
        if (data.status !== 0) return this.$message.warning(data.message);
        this.$message.success(data.message);
        this.closeDialog();
        this.$emit('getParamCategory');
      },
    },
  };
</script>

<style scoped>

</style>
